import type { FormDataOf } from '../../../../../types/templates';
import { disneyEspnVS } from '..';
import { SPORT_CONFIG } from '../data/sports';

type FormData = FormDataOf<typeof disneyEspnVS>;
type Option = { value: string; label?: string };

export const getSportOptions = (
  fieldKey: string,
  formData: FormData,
  baseOptions?: Option[]
): Option[] | undefined => {
  const { sport, team1, team2 } = formData;
  if (!sport) return baseOptions;
  const sportData = SPORT_CONFIG[sport as keyof typeof SPORT_CONFIG];

  if (fieldKey === 'league') return sportData?.leagues || baseOptions;
  if (fieldKey === 'tournament') return sportData?.tournaments || baseOptions;

  if (fieldKey === 'team1' || fieldKey === 'team2') {
    let options: Option[] = sportData?.teams || baseOptions || [];
    if (fieldKey === 'team1' && team2) options = options.filter(opt => opt.value !== team2);
    if (fieldKey === 'team2' && team1) options = options.filter(opt => opt.value !== team1);
    return options;
  }

  return baseOptions;
};
